const PartnerStatus = ({ isPartner }) => {
  return (
    <span className={`badge badge-${isPartner ? 'success' : 'danger'}`}>
      {isPartner ? 'Yes' : 'No'}
    </span>
  );
};

export default PartnerStatus;
